module.exports = __webpack_public_path__ + "img/2164738.59250d9b.png";